import CircularProgress from 'fuse-ui/components/CircularProgress';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import cx from 'classnames';

const styles = theme => ( {
    spinnerWrapper: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        padding: theme.spacing.unit,
        width: '100%',
    }
} );

const LoadingSpinner = ( { classes, className, color, size } ) => {
    return (
        <div className={cx( classes.spinnerWrapper, className )}>
            <CircularProgress size={size} style={{ color }}  />
        </div>
    );
};

LoadingSpinner.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
};

LoadingSpinner.defaultProps = {
    size: 'medium',
};

export default withStyles( styles )( LoadingSpinner );
